<script setup lang="ts">

</script>

<template>
  <p>{{ $route.name }}</p>
</template>
